import {colors, tokens, fonts} from '@commercial-helios/ui/theme'
import styled from 'styled-components'

import {Section} from '@helios/shared/styles/grid'

export const Wrapper = styled.div`
    overflow-x: hidden;
`

export const PerksSection = styled(Section)`
    strong {
        font-weight: ${fonts.weights.normal};
        background: ${colors.background.purple};
    }
`

export const FetchSection = styled(Section)`
    strong {
        font-weight: ${fonts.weights.normal};
        background: ${colors.background.yellow};
    }
`

export const BenefitsTitleSection = styled(Section)`
    > * {
        max-width: 620px;
    }
`

export const AddCardHeader = styled.div`
    display: grid;
    align-content: start;
    gap: ${tokens.spacing20};
`
